import { defineComponent, PropType } from 'vue';
import { ApplicationItem } from '/blocks/common/applications/search-apps/types';

export const ApplicationCard = defineComponent({
    name: 'ApplicationCard',
    props: {
        application: {
            type: Object as PropType<ApplicationItem>,
            required: true
        }
    },
    setup(props, { emit }) {
        return () => (
            <li class="search-apps__templates-item">
                <a class="search-apps__templates-link" id={props.application.id.toString()} href={'app/' + props.application.slug + '/'}>
                    <picture class="search-apps__templates-logo-container">
                        <img class="search-apps__templates-logo" src={props.application.icon === '' ? '' : props.application.icon}/>
                    </picture>
                    <p class="search-apps__templates-name">{props.application.name}</p>
                </a>
            </li>
        )
    }
})

export type ApplicationCard = InstanceType<typeof ApplicationCard>